import React, { useEffect, useState } from 'react';
import Div100vh from 'react-div-100vh';
import safeAreaInsets from 'safe-area-insets';
import Navbar from '../components/common/Navbar';
import { Outlet, useLocation } from 'react-router-dom';
import ProgressOverlay from 'components/ProgressOverlay';
import ShopperAvailabilityOverlay from 'components/ShopperAvailabilityOverlay';
import { useOrder } from 'context/OrderContext';
import ScrollToTop from '../components/ScrollToTop';

const MobileLayout = () => {
	const { orderDetails } = useOrder();
	const location = useLocation();
	const hideNavbar = location.pathname.startsWith('/product/') || location.pathname.startsWith('/scan');
	const [safeInsets, setSafeInsets] = useState({ top: 0, bottom: 0, left: 0, right: 0 });
	const [isIPhone, setIsIPhone] = useState(false);

	useEffect(() => {
		// Detect iPhone devices
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		const isiPhone = /iPhone/i.test(userAgent);
		setIsIPhone(isiPhone);

		// Get safe area insets
		const insets = {
			top: safeAreaInsets.top,
			bottom: safeAreaInsets.bottom,
			left: safeAreaInsets.left,
			right: safeAreaInsets.right
		};
		setSafeInsets(insets);

		// Update on resize/orientation change
		const handleResize = () => {
			const newInsets = {
				top: safeAreaInsets.top,
				bottom: safeAreaInsets.bottom,
				left: safeAreaInsets.left,
				right: safeAreaInsets.right
			};
			setSafeInsets(newInsets);
		};

		window.addEventListener('resize', handleResize);
		window.addEventListener('orientationchange', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
			window.removeEventListener('orientationchange', handleResize);
		};
	}, []);
	const mainStyle = {
		paddingBottom: `calc(64px + ${safeInsets.bottom}px)`
	};

	return (
		<Div100vh
			className='flex flex-col'
			style={{ paddingTop: `${safeInsets.top}px` }}
		>
			<ScrollToTop />
			<main 
				className='flex-1 overflow-y-auto'
				style={!hideNavbar ? mainStyle : {}}
			>
				<Outlet />
				{orderDetails && <ProgressOverlay />}
				<ShopperAvailabilityOverlay />
				{/* <CameraOverlay /> */}
			</main>
			{!hideNavbar && <Navbar safeInsets={safeInsets} />}
		</Div100vh>
	);
};

export default MobileLayout;